module.exports = __webpack_public_path__ + "media/images/login/login_btm-f354ef5ef7328ad67a0c7c3d9cff97cc.gif";